import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import {
  Box,
  Chip,
  Table,
  Paper,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Typography,
  TableContainer,
} from "@mui/material";

import Title from "../../../common/Title";
import ApiLogHistory from "../../../common/ApiLogHistory";

import useAxios from "../../../../hooks/useAxios";
import { __getMmsLog } from "../../../../api/sim";
import { getChipColor } from "../../../../constants/value";

const TmobilejMmsHistory = (props) => {
  const [mmsHistory, setMmsHistory] = useState([]);
  const { mms_id } = useParams();

  const [response, call, loading] = useAxios({
    ...__getMmsLog(mms_id),
  });

  useEffect(() => {
    if (response && response.status) {
      setMmsHistory(response.data);
    }
  }, [response]);

  useEffect(() => {
    call();
  }, []);

  return loading ? (
    <Title content="Please wait..." variant="subtitle2" gutterBottom />
  ) : (
    <>
      <Box mb={2} pt={2}>
        <Typography variant="h5" align="left">
          MMS Log
        </Typography>
      </Box>

      {response && mmsHistory.data ? (
        <>
          <Box
            sx={{ width: "100%", mb: 5 }}
            display="flex"
            alignItems="center"
            flexDirection="column"
          >
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">MSISDN</TableCell>
                    <TableCell align="left">Batch ID</TableCell>
                    <TableCell align="left">MMS</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">Last Updated</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="left">{mmsHistory.data.msisdn}</TableCell>
                    <TableCell align="left">
                      <Link
                        underline="none"
                        to={`/tmobilej/mms/batch/${mmsHistory.data.batch_id}`}
                      >
                        {mmsHistory.data.batch_id}
                      </Link>
                    </TableCell>
                    <TableCell align="left">
                      {mmsHistory.data.enable ? "Enable" : "Disable"}
                    </TableCell>
                    <TableCell align="left">
                      <Chip
                        label={mmsHistory.data.status}
                        size="small"
                        color={getChipColor(mmsHistory.data.status)}
                      />
                    </TableCell>
                    <TableCell align="left">
                      {mmsHistory.data.last_updated &&
                        `${format(
                          new Date(mmsHistory.data.last_updated),
                          "MMMM d, y hh:mm a"
                        )}`}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <ApiLogHistory data={mmsHistory.history.data} />
        </>
      ) : (
        <Box mb={2} pt={2}>
          <Typography variant="h5" align="left">
            No Data
          </Typography>
        </Box>
      )}
    </>
  );
};

export default TmobilejMmsHistory;
